import { Dispatch, SetStateAction } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useTranslationContext } from "context/TranslationContext";
import { replaceSegmentsFromRoutes } from "helpers/replaceSegmentsFromRoutes";
import cn from "lib/cn";

import { ENav, TNavItem } from "components/Layout/types";
import { buSlugParam } from "routes/constants";

import styles from "./NavItem.module.css";

export interface NavItemProps {
  id?: string;
  nav: TNavItem;
  activeNav: ENav | undefined;
  collapsed: boolean;
  setCollapsed: Dispatch<SetStateAction<boolean>>;
}

const NavItem = ({ id, nav, activeNav, setCollapsed }: NavItemProps) => {
  const navigate = useNavigate();
  const { buSlug } = useParams();
  const { t } = useTranslationContext();

  const handleClickNav = () => {
    if (activeNav !== nav.name) {
      let routeToRedirect = nav.href;

      if (buSlug) {
        routeToRedirect = replaceSegmentsFromRoutes({
          params: [buSlugParam],
          replacer: [buSlug],
          route: nav.href,
        });
      }

      navigate(routeToRedirect);
    }
    setCollapsed(true);
  };

  return (
    <button
      id={id}
      data-testid={id}
      onClick={handleClickNav}
      className={cn([
        "flex items-center w-full font-normal",
        "hover:bg-primary-800",
        activeNav === nav.name && "bg-primary-800 text-primary-300",
        styles.navItem,
      ])}
    >
      <div className="flex">
        <div
          className={cn(
            styles.separator,
            activeNav === nav.name && styles.separatorActive
          )}
        />
        <div className={cn("flex space-x-6 px-4 py-4", styles.navItemWrapper)}>
          <div
            className={cn(
              "flex justify-center items-center",
              activeNav === nav.name && styles.menuActive
            )}
          >
            {nav.icon}
          </div>
          <span className="text-base whitespace-pre break-keep overflow-hidden">
            {t(nav.label)}
          </span>
        </div>
      </div>
    </button>
  );
};

export default NavItem;
